import { ReactNode } from "react";
import { FCX } from "@datassential/platform-ui-lib";
import cn from "classnames";
import { BsStars } from "react-icons/bs";
import Skeleton from "@components/Skeleton";
import "./InsightsSummaryCard.scss";

interface Props {
    title: string;
    /** Inline content rendered next to the title, e.g. a "on the menu at N chains" link. */
    headerExtra?: ReactNode;
    bullets: string[];
    isLoading: boolean;
}

/** Placeholder line lengths, mimicking the ragged right edge of the real bullets. */
const SKELETON_LINE_WIDTHS = ['100%', '64%', '92%', '58%', '86%'];

/** `del-N` steps between consecutive bullets; the first bullet starts at one step in. */
const REVEAL_DELAY_STEP = 2;

const InsightsSummaryCard: FCX<Props> = ({
    className,
    testId,
    title,
    headerExtra,
    bullets,
    isLoading,
}) => (
    <div className={cn("InsightsSummaryCard", className)} data-testid={testId}>
        <div className="InsightsSummaryCard__header">
            <BsStars className="InsightsSummaryCard__ai-icon"/>
            <span className="InsightsSummaryCard__title">{title}</span>
            {headerExtra && (
                <span className="InsightsSummaryCard__header-extra">{headerExtra}</span>
            )}
        </div>

        {isLoading ? (
            <div
                className="InsightsSummaryCard__skeleton"
                data-testid={testId ? `${testId}Skeleton` : undefined}
            >
                {SKELETON_LINE_WIDTHS.map(width => (
                    <Skeleton key={width} height={14} style={{ width }}/>
                ))}
            </div>
        ) : (
            <ul className="InsightsSummaryCard__list">
                {bullets.map((text, index) => (
                    <li
                        className={`InsightsSummaryCard__item appears-left del-${(index + 1) * REVEAL_DELAY_STEP}`}
                        key={`${index}-${text}`}
                    >
                        {text}
                    </li>
                ))}
            </ul>
        )}
    </div>
);

export default InsightsSummaryCard;
